import React, { Component } from 'react';
import { UtilService } from 'hay-core-react';
import { pastaDaChave, corDoTema } from '../../enums/catalogoTemas';

// Rótulo de opção/valor do dropdown de Template.tema: bolinha com a cor predominante do tema +
// label traduzido ("Vela Blue - Dark" etc.). Usado via itemTemplateCustom/valueTemplateCustom do
// ModelDropDown. Espelho de hay-hotspot/assets/reactweb/src/components/ui/TemaCaptiveOptionLabel.js.
class TemaOptionLabel extends Component {
  render() {
    const { chave } = this.props;
    if (!chave) {
      return <div className="flex align-items-center"><div>Selecione</div></div>;
    }
    const cor = corDoTema(pastaDaChave(chave));
    return (
      <div className="flex align-items-center gap-2">
        <span style={{
          width: '0.85rem',
          height: '0.85rem',
          borderRadius: '50%',
          background: cor,
          flexShrink: 0,
          display: 'inline-block',
          border: '1px solid rgba(0,0,0,0.1)',
        }} />
        <span>{UtilService.traduzir(chave)}</span>
      </div>
    );
  }
}

export default TemaOptionLabel;
